<h1 mat-dialog-title>
  {{ 'woa.funFact' | translate }}
</h1>
<mat-dialog-content>
  {{fact}}
</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close class="close" tabindex="0">
    <img alt="close modal" src="assets/img/exit-btn.svg">
  </button>
</div>